var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select-base',{ref:"selectBase",staticClass:"round-select",attrs:{"options":_vm.options,"optionDefault":_vm.optionDefault},on:{"change":_vm.changeEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }